import {
    DataGrid,
    TreeDataGrid,
    TabDataGrid,
    TabDataGridItem
} from './data-grid'
import {
    ConfirmDialog,
    PopConfirm,
    Text,
    Sms,
    Tip,
    ImageUpload,
    Select,
    VCascader,
    SearchInput,
    Texts,
    CountTo
} from './widgets'
import {
    DetailContainer,
    DetailSection,
    DetailEllipsis
} from './detail'
import {
    BlankLayout
} from './layout'
import Cascader from './cascader'
import createImageManager from './functional/image-manager'
import createImagePreview from './functional/image-preview'
import { Steps, Step } from './steps'
import installFormatFilter from './filters/format'
import installDirectives from './directives'
import { wangeditor } from './editor'
import Upload from './upload'
import Uploader from './uploader'

const components = {
    DataGrid,
    TreeDataGrid,
    TabDataGrid,
    TabDataGridItem,
    ConfirmDialog,
    PopConfirm,
    DetailContainer,
    DetailSection,
    DetailEllipsis,
    BlankLayout,
    Cascader,
    Text,
    Steps,
    Step,
    Sms,
    Tip,
    ImageUpload,
    Upload,
    Uploader,
    Select,
    VCascader,
    SearchInput,
    Texts,
    CountTo,
    wangeditor
}




const install = (Vue, options) => {
    Vue.prototype.$FRAMEWORK = {
        dictApi: options.dictApi,
        upload: options.upload,
        captchaUrl: options.captchaUrl,
        index: options.index
    }
    // install functional comps
    Vue.prototype.$createImageManager = createImageManager(Vue)
    Vue.prototype.$createImagePreview = createImagePreview(Vue)
    installFormatFilter(Vue)
    installDirectives(Vue)
    // install comps
    for (let key in components) {
        if (components.hasOwnProperty(key)) {
          let component = components[key]
          if (component.install) component.install(Vue)
          else {
            Vue.component(component.name ? component.name : key, component)
          }
        }
    }
}

export default {
    install
}



// WEBPACK FOOTER //
// ./src/components/framework/install.js